const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const fetchConfigs = () => {
        return async () => {
            try {
                var response = await axiosCall('configurations');
                return response.data;
            } catch (err) {
                console.error(err);
            }
        };
    };

    return {
        fetchConfigs,
    };
};

export default initActions;
